import { cn } from '@utils/styles';
import { getImageUrl } from '@utils/nutrition/getImageUrl';
import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';
import { useNavigate } from 'react-router-dom';
import { EventTracker } from '@/utils';

interface ImporveMyScoreInfo {
  id: number;
  image_url: string[];
  number_of_foods_and_ingredients: number;
}

interface HealthL4ImproveMyScoreInfoProp {
  improveMyScoreInfo: ImporveMyScoreInfo;
}

export const HealthL4ImproveMyScoreInfo = ({
  improveMyScoreInfo,
}: HealthL4ImproveMyScoreInfoProp) => {
  const {
    id,
    image_url: images = [],
    number_of_foods_and_ingredients,
  } = improveMyScoreInfo || {};
  const navigate = useNavigate();

  const onClickImproveScore = () => {
    EventTracker.trackEvent('health', 'health_improve_my_score');
    navigate(`/health/improve-my-score/${Number(id)}`);
  };

  return (
    <button
      key={id}
      onClick={onClickImproveScore}
      className={cn(
        'p-5 bg-white text-black rounded-lg shadow-md items-center w-full text-left transition-transform focus:outline-none mt-12',
      )}
    >
      <div>
        <h3 className="typography-title">Improve This Score</h3>
        {images.length > 0 && (
          <div className="flex justify-between items-end">
            <div className="flex mt-4">
              {images.map((image, index) => (
                <img
                  key={`${image}-${index}-booster-img`}
                  src={getImageUrl(image)}
                  alt={`booster-${index}`}
                  className="w-14 h-14 rounded-full border border-secondary mr-[-16px]"
                />
              ))}
            </div>

            <div className="flex items-center transition-colors">
              <span className="typography-caption1">{`${number_of_foods_and_ingredients} foods & ingredients`}</span>
              <ChevronRightIcon className="ml-1" />
            </div>
          </div>
        )}
      </div>
    </button>
  );
};
